<template>
  <div>
    <panel-modal>
      <notifications-modal v-if="modalStateFor(vueModalID.addNewNotification).isVisible"
                           :state="modalStateFor(vueModalID.addNewNotification)"
                           :index="vueModalID.addNewNotification"
                           :key="selectedNotification.client_id"
                           @toggle-modal="hideModal(vueModalID.addNewNotification)"
                           :parent="parent"
                           :dynamic-fields-handler="dynamicFieldsHandler"
                           :permittee-options="permitteeOptions"
                           :notification="selectedNotification"></notifications-modal>
    </panel-modal>

    <panel-block id="pn-send-email" class="condition">
      <panel-item>

        <notification-display v-for="(notification, i) in notifications"
                              :notification="notification"
                              :i="i"
                              :key="notification.client_id"
                              v-on:edit:notification="editNotification"></notification-display>

        <panel-actions>
          <button @click="startNotification" type="button" class="btn grey-to-blue full-sz" id="add-notification">
            Create Notification
          </button>
        </panel-actions>
      </panel-item>
    </panel-block>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import NotificationsModal from "./configure-notification-modal.vue";
  import NotificationDisplay from "~/components/notificationDisplay.vue";
  import DurationAndTimeHelper from "~/helpers/durationAndTimeHelper";
  import NotificationFactory from "~/models/notifications/notificationFactory";
  import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
  import DynamicFieldsHandler from "~/models/dynamicFields/handlers/dynamicFieldsHandler";

  export default Vue.extend({
    props:{
      parent: {
        required: true,
      },
      notificationFactory:{
        default: ()=> NotificationFactory
      },
      permitteeOptions:{
        type: Array as () => IVOptionSetLocal[]
      },
      dynamicFieldsHandler: {
        type: Object as () => DynamicFieldsHandler,
      },
    },
    components: {
      NotificationDisplay,
      NotificationsModal,
    },
    data: function () {
      return {
        selectedNotification: null,
        DurationAndTimeHelper: DurationAndTimeHelper,
      };
    },
    computed: {
      notifications: {
        get(): Notification[] {
          return this.parent.notificationsArray;
        }
      }
    },
    methods: {
      startNotification(): void {
        this.selectedNotification = this.notificationFactory.create(this.parent);
        this.showModal(this.vueModalID.addNewNotification);
      },
      editNotification(notification: Notification): void {
        this.selectedNotification = notification;
        this.selectedNotification.triggerChanges = false;
        this.showModal(this.vueModalID.addNewNotification);
      },
    }
  });
</script>

